module.exports = __webpack_public_path__ + "img/direct-notification.b86ebfc1.svg";